import { Pedido } from '../types/pedido';

const mapFormaPagamentoLabel = (forma?: string): string => {
  if (!forma) return '';
  const value = forma.toLowerCase();
  if (value.includes('pix')) return 'PIX';
  if (value.includes('débito') || value.includes('debito')) return 'DEBITO';
  if (value.includes('crédito') || value.includes('credito')) return 'CREDITO';
  if (value.includes('dinheiro')) return 'DINHEIRO';
  return forma;
};

export const buildComandaHtml = (
  pedido: Pedido,
  formatCurrency: (value: number) => string,
  formatDate: (dateString: string) => string,
): string => {
  const safeEndereco = pedido.endereco || { rua: '', numero: '', bairro: '', cidade: '', estado: '', cep: '' };
  const itens = Array.isArray(pedido.itens) ? pedido.itens : [];
  const hasCouponDiscount = typeof pedido.couponDiscount === 'number' && pedido.couponDiscount > 0;

  return `
      <html>
        <head>
          <meta charSet="utf-8" />
          <title>Comanda Pedido #${pedido.idPedido}</title>
          <style>
            @page { size: 80mm 150mm; margin: 2mm 3mm; }
            body {
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
              font-size: 14px;
              margin: 0;
              padding: 0;
              width: 80mm;
            }
            h1, h2, h3 { margin: 2px 0; }
            .comanda-container {
              box-sizing: border-box;
              width: 100%;
              padding: 4px 6px;
              border: 1px dashed #9e9e9e;
            }
            .section { margin-top: 6px; }
            .section-title { font-weight: bold; border-bottom: 1px solid #000; padding-bottom: 4px; margin-bottom: 6px; font-size: 14px; }
            .section + .section { border-top: 1px solid #000; padding-top: 6px; margin-top: 8px; }
            .info-linha { display: flex; justify-content: space-between; }
            .itens-table { width: 100%; border-collapse: collapse; margin-top: 4px; }
            .itens-table th, .itens-table td { padding: 3px 0; border-bottom: 1px solid #bdbdbd; font-size: 14px; }
            .right { text-align: right; }
            .center { text-align: center; }
            .pedido-id {
              font-size: 22px;
              font-weight: bold;
              margin: 2px 0 6px 0;
              text-align: center;
            }
            .pedido-titulo {
              font-size: 14px;
              text-align: center;
            }
          </style>
        </head>
        <body>
          <div class="comanda-container">
            <div class="pedido-titulo">Comanda Pedido</div>
            <div class="pedido-id">#${pedido.idPedido}</div>

            <div class="section">
              <div class="section-title">Cliente</div>
              <div>${pedido.cliente}</div>
              <div>Tel: ${pedido.telefone || '-'}</div>
              <div>${safeEndereco.rua || ''}, ${safeEndereco.numero || ''}</div>
              <div>${safeEndereco.bairro || ''} - ${safeEndereco.cidade || ''}</div>
              ${safeEndereco.complemento ? `<div>Ref.: ${safeEndereco.complemento}</div>` : ''}
            </div>

            ${pedido.formaPagamento
              ? `
            <div class="section">
              <div style="font-weight: bold;">Pagamento: ${mapFormaPagamentoLabel(pedido.formaPagamento)}</div>
            </div>
            `
              : ''}

            <div class="section">
              <div class="section-title">Itens</div>
              <table class="itens-table">
                <thead>
                  <tr>
                    <th>Qtd</th>
                    <th>Item</th>
                    <th class="right">Total</th>
                  </tr>
                </thead>
                <tbody>
                  ${itens
                    .map(
                      (item) => `
                        <tr>
                          <td>${item?.quantidade || 0}x</td>
                          <td>
                            ${item?.nome || 'Item sem nome'}
                            ${item?.observacao ? `<br /><small>${item.observacao}</small>` : ''}
                          </td>
                          <td class="right">${formatCurrency((item?.preco || 0) * (item?.quantidade || 0))}</td>
                        </tr>
                      `,
                    )
                    .join('')}
                </tbody>
              </table>
            </div>

            <div class="section">
              <div class="info-linha">
                <span>Valor bruto dos Itens:</span>
                <span>${formatCurrency((pedido as any).valorBrutoItens || 0)}</span>
              </div>
              <div class="info-linha">
                <span>Valor dos Itens:</span>
                <span>${formatCurrency(pedido.valorItens || 0)}</span>
              </div>
              <div class="info-linha">
                <span>Desconto combos:</span>
                <span>${formatCurrency((pedido as any).descontoCombos || 0)}</span>
              </div>
              <div class="info-linha">
                <span>Taxa de Entrega:</span>
                <span>${formatCurrency(pedido.taxaEntrega || 0)}</span>
              </div>
              ${hasCouponDiscount
                ? `
              <div class="info-linha" style="color: #d32f2f;">
                <span>Desconto de cupom${pedido.couponCode ? ` (${pedido.couponCode})` : ''}:</span>
                <span>-${formatCurrency(pedido.couponDiscount || 0)}</span>
              </div>
              `
                : ''}
              <div class="info-linha" style="font-weight: bold; margin-top: 4px;">
                <span>Total:</span>
                <span>${formatCurrency(pedido.valorTotal || 0)}</span>
              </div>
            </div>

            ${pedido.observacao
              ? `
              <div class="section">
                <div class="section-title">Observações</div>
                <div>${pedido.observacao}</div>
              </div>
            `
              : ''}

            <div class="section">
              <div>Status: ${pedido.status?.replace('_', ' ')}</div>
              <div>Data: ${formatDate(String(pedido.dataCriacao))}</div>
            </div>
          </div>
        </body>
      </html>
    `;
};
